import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, map, of } from "rxjs";
import { IUser } from "src/app/models/Identity/user";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";
import { environment } from "src/environments/environment";
import { IPayloadUserData } from "../../interfaces/manage-users.interface";

@Injectable({
  providedIn: "root",
})
export class UsersService {
  //Se controla con email como id
  usersEndpoint = `${environment.apiUrlCap}/api/users`;

  constructor(private http: HttpClient) {}

  getUsers(): Observable<IUser[]> {
    //-H 'accept: text/plain'
    return this.http
      .get<ResponseDataInterfaces<IUser[]>>(`${this.usersEndpoint}`)
      .pipe(
        map(({ data }) => data),
        catchError(err => of([]))
      );
  }

  getUserByEmail(email: string): Observable<IUser | null> {
    return this.http
      .get<ResponseDataInterfaces<IUser | null>>(
        `${this.usersEndpoint}/email/${email}`
      )
      .pipe(
        map(resp => resp.data),
        catchError(err => of(null))
      );
  }

  getUserById(id: number) {
    //-H 'accept: text/plain'
    return this.http
      .get<ResponseDataInterfaces<IUser | null>>(
        `${environment.apiUrlCap}/api/users/` + id
      )
      .pipe(
        map(resp => resp.data),
        catchError(err => of(null))
      );
  }

  deleteUserById(id: number) {
    //-H 'accept: text/plain'
    return this.http
      .delete<ResponseDataInterfaces<boolean>>(
        `${environment.apiUrlCap}/api/users/` + id
      )
      .pipe(map(({ data }) => data));
  }

  postUser(user: IPayloadUserData): Observable<IUser> {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        accept: "*/*",
      }),
    };

    return this.http
      .post<ResponseDataInterfaces<IUser>>(this.usersEndpoint, user, options)
      .pipe(map(({ data }) => data));
  }

  putUser(user: IPayloadUserData): Observable<IUser> {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        accept: "*/*",
      }),
    };

    return this.http
      .put<ResponseDataInterfaces<IUser>>(this.usersEndpoint, user, options)
      .pipe(map(({ data }) => data));
  }

  getUserTeam(userId: string): Observable<IUser[]> {
    const url = `${this.usersEndpoint}/headDevelopment/team/${userId}`;
    return this.http
      .get<ResponseDataInterfaces<IUser[]>>(url)
      .pipe(map(({ data }) => data));
  }
  // Subir archivo para carga masiva de usuarios
  uploadUsersFile(file: File): Observable<void> {
    const formData = new FormData();
    formData.append("createTemplate", file, file.name);

    return this.http.post<void>(`${this.usersEndpoint}/cargaMasiva`, formData);
  }

  // Actualizar usuarios mediante archivo
  updateUsersFile(file: File): Observable<void> {
    const formData = new FormData();
    formData.append("updateTemplate", file, file.name);

    return this.http.put<void>(`${this.usersEndpoint}/cargaMasiva`, formData);
  }

  // Descargar plantilla de creación de usuarios
  getCreateTemplate(): Observable<string> {
    return this.http
      .get<ResponseDataInterfaces<string>>(
        `${environment.apiUrlCap}/api/fileStorage/userCreateTemplate`
      )
      .pipe(map(({ data }) => data));
  }

  // Descargar plantilla de actualización de usuarios
  getUpdateTemplate(): Observable<string> {
    return this.http
      .get<ResponseDataInterfaces<string>>(
        `${environment.apiUrlCap}/api/fileStorage/userUpdateTemplate`
      )
      .pipe(map(({ data }) => data));
  }
}
